import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import {
  Badge,
  Col, Container, Row,
} from 'reactstrap';
import debounce from '../../../../helpers/debounce';
import calculateSimilarity from '../../../../helpers/similarity';
import {
  createErrorMessage,
  createSuccessMessage,
  createWarningMessage,
} from '../../../../helpers/notification';
import {
  fetchStudentsBySubject,
  moveStudentSection,
} from '../../../../redux/actions/studentSubjectsActions';
import Confirm from '../../../../shared/components/Confirm';
import LoadingSpinner from '../../../../shared/components/LoadingSpinner';
import MoveSectionForm from './MoveSectionForm';

class MoveSectionFormContainer extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      filterValue: '',
      sortColumn: 'name',
      sortType: 'desc',
      subject: null,
      students: [],
      sections: [],
      editedStudentEnrollments: [],
      checkAll: false,
      section: { value: 0 },
    };

    this.handleOnStudentChange = this.handleOnStudentChange.bind(this);
    this.debouncedHandleFilterChangeText = debounce(this.handleFilterChangeText, 500);
  }

  componentDidMount() {
    this.fetchFormDatas({});
  }

  fetchFormDatas = ({ filterValue = '' }) => {
    const { id: subjectId } = this.props;
    fetchStudentsBySubject({
      subjectId,
      onSuccess: ({ students = [], sections = [], subject }) => {
        this.setState({
          subject,
          students,
          sections: sections.filter(s => s.value !== Number(subjectId)),
          loading: false,
          filterValue,
        });
      },
      onError: () => {
        this.setState({
          loading: false,
        });
        createErrorMessage('Error al intentar cargar los datos requeridos');
      },
    });
  }

  handleSubmit = (values) => {
    const { section } = this.state;

    const { students = [] } = values;

    const inscripcionToMove = students
      .filter(a => a.selected)
      .map(a => ({
        inscriptionId: a.inscriptionId,
      }));

    if (inscripcionToMove.length === 0) {
      return;
    }

    const alumnosToShow = students
      .filter(a => a.selected)
      .map(({ doc, name }) => {
        const fullName = name.split(', ');
        const [firstName] = fullName[0].split(' ');
        const [lastName] = fullName[1].split(' ');

        return (
          <div style={{
            width: '50%',
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'nowrap',
            justifyContent: 'flex-start',
            alignItems: 'baseline',
          }}
          >
            <span>{`${doc}, ${firstName} ${lastName}`}</span>
          </div>
        );
      });

    Confirm({
      title: 'Mover alumnos de materia',
      question: (
        <span>
          {
            `¿Estás seguro que deseas mover estos alumnos(${inscripcionToMove.length}) a la materia `
          }
          <Badge
            color="primary"
            style={{ fontSize: '12px', fontWeight: '600' }}
          >
            {section.label}
          </Badge>
          ?.
          <div style={{
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
          }}
          >
            {alumnosToShow}
          </div>
        </span>),
      yesLabel: 'Si, mover alumnos',
      noLabel: 'No, Volver',
      onConfirm: () => {
        this.setState({ loading: true });

        moveStudentSection({
          data: {
            subjectPeriodId: section.value,
            students: inscripcionToMove,
          },
          onSuccess: () => {
            this.setState({ loading: false });

            createSuccessMessage('Los alumnos fueron cambiados de materia exitosamente');

            this.handleOnBack();
          },
          onError: (error) => {
            if (error.message) {
              createWarningMessage(error.message);
            } else {
              createErrorMessage('Ocurrió un error al intentar mover de materia');
            }
          },
        });
      },
    });
  }

  handleOnBack = () => {
    const { history } = this.props;
    history.goBack();
  }

  handleOnStudentChange = (value) => {
    this.setState({ section: value });
  }

  onCheckAllChanges = (evt) => {
    if (!evt.currentTarget) {
      return false;
    }

    const checkAll = evt.target.checked;

    const {
      editedStudentEnrollments,
      students,
    } = this.state;

    const newAlumnos = [...students];

    newAlumnos.forEach((stundent, index) => {
      newAlumnos[index] = {
        ...newAlumnos[index],
        selected: checkAll,
        changed: true,
      };

      const studentEnrollment = editedStudentEnrollments.find(i => i.studentId === stundent.studentId);
      if (!studentEnrollment) {
        const newData = {
          studentId: stundent.studentId,
          selected: checkAll,
        };

        editedStudentEnrollments[index] = {
          ...editedStudentEnrollments[index],
          ...newData,
        };
      }
    });

    this.setState({
      students: newAlumnos,
      editedStudentEnrollments,
      checkAll,
    });

    return true;
  }

  handleChangeSelect = section => this.setState({ section });

  onStudentEnrollmentChanges = (evt, student) => {
    if (!evt.currentTarget) {
      return false;
    }

    const id = student.inscriptionId;

    const {
      editedStudentEnrollments,
      students,
    } = this.state;

    const newAlumnos = [...students];

    const elementsIndex = newAlumnos.findIndex(s => s.inscriptionId === id);
    newAlumnos[elementsIndex] = {
      ...newAlumnos[elementsIndex],
      selected: !newAlumnos[elementsIndex].selected,
      changed: true,
    };

    const studentEnrollment = editedStudentEnrollments.find(i => i.inscriptionId === id);
    if (!studentEnrollment) {
      this.setState({
        students: newAlumnos,
        editedStudentEnrollments: [
          ...editedStudentEnrollments, {
            inscriptionId: id,
            selected: evt.target.checked,
          },
        ],
      });
    } else {
      studentEnrollment.selected = evt.target.checked;
      this.setState({
        students: newAlumnos,
        editedStudentEnrollments,
      });
    }

    return true;
  }

  handleFilterChangeText = ({ target: { value } }) => {
    const { loading } = this.state;
    if (loading) {
      this.setState({
        filterValue: value,
      });
      return;
    }

    const { students = [] } = this.state;
    if (students.length === 0 && value) {
      this.fetchFormDatas({ loadStudents: true, filterValue: value });
      return;
    }

    this.setState({
      filterValue: value,
    });
  };

  transformText = (value = '') => `${value}`.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();

  getAlumnos = () => {
    const {
      filterValue = '',
      sortColumn,
      sortType,
      students = [],
    } = this.state;

    const filter = this.transformText(filterValue);

    const result = students
      .filter(tma => (
        this.transformText(`${tma.doc}/${tma.year}`).includes(filter)
        || this.transformText(tma.name).includes(filter)
        || this.transformText(tma.email).includes(filter)
      ))
      .sort((a, b) => (
        sortType !== 'asc' ? a[sortColumn].localeCompare(b[sortColumn]) : b[sortColumn].localeCompare(a[sortColumn])
      ));

    return result;
  };

  onShowOnlyEnrolledChanges = (evt) => {
    if (!evt.currentTarget) {
      return false;
    }

    this.fetchFormDatas();

    return true;
  }

  getShortMalla = (malla) => {
    const partes = malla.split(' ');
    if (partes.length < 3) {
      return malla;
    }

    return `${partes[1].substring(0, 3)} ${partes[2]}`;
  }

  render() {
    const { history } = this.props;
    const {
      subject,
      loading,
      filterValue,
      checkAll,
      editedStudentEnrollments = [],
      sections = [],
      section,
    } = this.state;

    if (loading || !subject) {
      return <LoadingSpinner />;
    }

    const subjectText = `${subject.materia} ${this.getShortMalla(subject.malla)}`;
    const itemsSections = sections
      .filter(s => calculateSimilarity(`${s.label} ${s.item.malla}`, subjectText, 0.5).isSimilar)
      .map(s => ({
        ...s,
        label: `${s.item.codigo}-${s.label} ${s.item.seccion} ${s.item.malla}, ${s.item.semestre}º ${s.item.anho} `,
      }));

    return (
      <Container>
        <Row>
          <Col md={12}>
            <h3 className="page-title">
              Materia actual:
              <Badge
                style={{ fontSize: 18 }}
                color="primary"
                pill
              >
                {subject.codigo}-{subject.materia}
              </Badge>
              <Badge
                style={{ fontSize: 18 }}
                color="primary"
                pill
              >
                {subject.seccion}
              </Badge>

              <Badge
                style={{ fontSize: 18 }}
                color="secondary"
                pill
              >
                {this.getShortMalla(subject.malla)}
              </Badge>
              <h4 className="page-subtitle" style={{ marginLeft: '1rem', marginTop: '1rem' }}>
                Seleccionar los alumnos de materia a ser movidos a otra materia
              </h4>
            </h3>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <MoveSectionForm
              {...subject}
              onSubmit={this.handleSubmit}
              onBack={this.handleOnBack}
              onAlumnoChanges={this.handleOnStudentChange}
              onStudentEnrollmentChanges={this.onStudentEnrollmentChanges}
              onCheckAllChanges={this.onCheckAllChanges}
              handleFilterChangeText={this.debouncedHandleFilterChangeText}
              onChangeSelect={this.handleChangeSelect}
              initialValues={subject}
              history={history}
              students={this.getAlumnos()}
              editedStudentEnrollments={editedStudentEnrollments}
              sections={itemsSections}
              section={section}
              filterValue={filterValue}
              checkAll={checkAll}
              enableReinitialize
            />
          </Col>
        </Row>
      </Container>
    );
  }
}

MoveSectionFormContainer.propTypes = {
  id: PropTypes.string.isRequired,
  idPeriodo: PropTypes.string.isRequired,
  history: PropTypes.shape({}).isRequired,
};

export default MoveSectionFormContainer;
